import { CertificazioneCompetenzeStato, Classe } from ".";

export class CertificazioneCompetenzeClasse {
    id!: string;
    classe!: Classe;
    stato!: CertificazioneCompetenzeStato;
}